import { IOfferType } from '../../../types/offerTypeList';
import { EDealType, EOfferType } from '../../../utils/jsonQuery';

interface IOfferTCollectionType {
  dealType: EDealType;
  list: IOfferType[][];
}

export const OFFER_TYPES_RENT_RESIDENTIAL: IOfferType[][] = [
  [
    { label: 'Дом, дача', value: EOfferType.House },
    { label: 'Часть дома', value: EOfferType.HousePart },
    { label: 'Таунхаус', value: EOfferType.Townhouse },
  ],
];

export const OFFER_TYPES_SALE_RESIDENTIAL: IOfferType[][] = [
  [
    { label: 'Дом, дача', value: EOfferType.House },
    { label: 'Часть дома', value: EOfferType.HousePart },
    { label: 'Таунхаус', value: EOfferType.Townhouse },
    { label: 'Участок', value: EOfferType.Land },
  ],
];

export const OFFER_TYPES: IOfferTCollectionType[] = [
  {
    dealType: EDealType.Sale,
    list: OFFER_TYPES_SALE_RESIDENTIAL,
  },
  {
    dealType: EDealType.RentLongterm,
    list: OFFER_TYPES_RENT_RESIDENTIAL,
  },
];
